<div
  id="overlay"
  class="fx-row fx-row-v-center fx-row-h-center"
  [class.visible]="isVisible"
  [ngStyle]="{ 'z-index': zIndex }"
  >
  @if (showSpinner) {
    <mat-spinner [diameter]="spinnerSize" [color]="spinnerColor"></mat-spinner>
  }
</div>
